var map = {
	"./01_listenKey.json": "gOrG",
	"./02_balance.json": "Zg2x",
	"./03_order.json": "4X8p",
	"./04_setting.json": "M7Po"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mzLI";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/account \.json$
// module id = mzLI
// module chunks = 3